import { render, staticRenderFns } from "./OverallPerformance.vue?vue&type=template&id=a4082ad8&scoped=true"
import script from "./OverallPerformance.vue?vue&type=script&lang=js"
export * from "./OverallPerformance.vue?vue&type=script&lang=js"
import style0 from "./OverallPerformance.vue?vue&type=style&index=0&id=a4082ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4082ad8",
  null
  
)

export default component.exports